import React from "react";
import { useLocation } from "react-router-dom";
import { motion } from "framer-motion";

export default function Route({
  name = "Route name",
  icon,
  onClick = null,
  urlPath = "",
  isCollapsed = false,
}) {
  const location = useLocation();
  const path = location.pathname.split("/")[2] || "home";
  const isActive = urlPath === path;

  return (
    <div
      onClick={onClick}
      className={`relative flex items-center px-4 py-2.5 cursor-pointer transition-all duration-300 group ${isCollapsed ? "justify-center" : "gap-4 mx-2 rounded-xl"
        } ${isActive
          ? "bg-[#e8ebf9] text-[#2d50e6] font-bold"
          : "text-slate-600 hover:bg-slate-100 hover:text-slate-900"
        }`}
    >
      {/* Active Indicator Line */}
      {isActive && !isCollapsed && (
        <motion.div
          layoutId="active-nav-indicator"
          className="absolute left-0 w-1 h-6 bg-indigo-500 rounded-full neon-glow"
        />
      )}

      <div className={`transition-transform duration-300 group-hover:scale-110 ${isActive ? "text-[#2d50e6]" : "text-slate-500"} ${isCollapsed ? "text-2xl" : "text-xl"}`}>
        {icon}
      </div>

      {!isCollapsed && (
        <span className="text-sm tracking-wide">
          {name}
        </span>
      )}

      {/* Glow dot for collapsed active state */}
      {isCollapsed && isActive && (
        <div className="absolute right-2 w-1.5 h-1.5 rounded-full bg-indigo-500 neon-glow" />
      )}
    </div>
  );
}

